import * as Yup from "yup";
import {
  campo_obligatorio,
  email_invalido,
  las_contrasenas_deben_coincidir,
  debe_contener_letras_mayusculas_y_minusculas_al_menos_1_caracter_numerico_y_el_tamano_debe_ser_de_6_a_15_caracteres,
} from "../../utils/traductor";

export function initialValues() {
  return {
    nombre: "",
    apellido: "",
    email: "",
    telefono: "",
    password: "",
    passwordRepetir: "",
    aceptoCondiciones: false,
  };
}

export function validationSchema() {
  return Yup.object({
    nombre: Yup.string().required(` ${campo_obligatorio} `),
    apellido: Yup.string().required(` ${campo_obligatorio} `),
    email: Yup.string()
      .email(` ${email_invalido} `)
      .required(` ${campo_obligatorio} `),
    telefono: Yup.string().required(` ${campo_obligatorio} `),
    password: Yup.string()
      .required(` ${campo_obligatorio} `)
      .matches(
        /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,15}$/,
        debe_contener_letras_mayusculas_y_minusculas_al_menos_1_caracter_numerico_y_el_tamano_debe_ser_de_6_a_15_caracteres
      ),
    passwordRepetir: Yup.string()
      .required(` ${campo_obligatorio} `)
      .matches(
        /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,15}$/,
        debe_contener_letras_mayusculas_y_minusculas_al_menos_1_caracter_numerico_y_el_tamano_debe_ser_de_6_a_15_caracteres
      )
      .oneOf([Yup.ref("password")], ` ${las_contrasenas_deben_coincidir} `),
    aceptoCondiciones: Yup.bool().isTrue(true),
  });
}
